export default __webpack_public_path__ + "static/media/five.ecbc5057.jpeg";